import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AuthProvider, TenantProvider, VendaProvider, ThemeProvider } from './contexts';
import { AppRoutes } from './routes';

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <TenantProvider>
            <VendaProvider>
              <AppRoutes />
            </VendaProvider>
          </TenantProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
